import {getRouteApi} from "@tanstack/react-router";

export const materialNotesRouteApi = getRouteApi("/_app/engineering/materials/$materialId/notes/");
